<template>
  <header
    class="sticky top-0 z-50 border-b transition-colors duration-300"
    :class="scrolled || menuOpen ? 'border-navy-100 bg-white/90 backdrop-blur-md' : 'border-transparent bg-white'"
  >
    <nav class="mx-auto flex max-w-7xl items-center justify-between gap-6 px-5 py-3 lg:px-8">
      <a href="#top" class="shrink-0" aria-label="MCLEANIT Ltd — home">
        <img src="../assets/mclogo.webp" alt="MCLEANIT Ltd, exterior cleaning services" class="h-11 w-auto sm:h-14" />
      </a>

      <ul class="hidden items-center gap-9 text-sm font-medium text-navy-700 lg:flex">
        <li v-for="link in links" :key="link.href">
          <a
            :href="link.href"
            class="relative py-2 transition hover:text-navy-900 after:absolute after:inset-x-0 after:-bottom-0.5 after:h-0.5 after:origin-left after:scale-x-0 after:bg-sky-400 after:transition-transform hover:after:scale-x-100"
          >{{ link.label }}</a>
        </li>
      </ul>

      <div class="hidden items-center gap-5 lg:flex">
        <a href="tel:+447534490921" class="text-sm font-semibold text-navy-900 hover:text-navy-600">
          <i class="fas fa-phone mr-2 text-xs text-sky-400"></i>07534 490921
        </a>
        <a href="#contact" class="btn-primary !px-6 !py-3">Get a free quote</a>
      </div>

      <button
        @click="menuOpen = !menuOpen"
        class="-mr-2 rounded-lg p-2.5 text-navy-900 transition hover:bg-navy-50 lg:hidden"
        aria-label="Toggle navigation menu"
        :aria-expanded="menuOpen"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path v-if="!menuOpen" stroke-linecap="round" d="M4 7h16M4 12h16M4 17h16" />
          <path v-else stroke-linecap="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </nav>

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="-translate-y-2 opacity-0"
      leave-active-class="transition duration-150 ease-in"
      leave-to-class="-translate-y-2 opacity-0"
    >
      <div v-if="menuOpen" class="border-t border-navy-100 bg-white px-5 pb-6 lg:hidden">
        <ul class="flex flex-col divide-y divide-navy-50 text-base font-medium text-navy-900">
          <li v-for="link in links" :key="link.href">
            <a :href="link.href" @click="menuOpen = false" class="block py-3.5">{{ link.label }}</a>
          </li>
        </ul>
        <div class="mt-5 flex flex-col gap-3">
          <a href="#contact" @click="menuOpen = false" class="btn-primary w-full">Get a free quote</a>
          <a href="tel:+447534490921" class="btn-ghost w-full">
            <i class="fas fa-phone text-xs text-sky-400"></i>07534 490921
          </a>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

const menuOpen = ref(false)
const scrolled = ref(false)

const links = [
  { href: '#services', label: 'Services' },
  { href: '#work', label: 'Our work' },
  { href: '#process', label: 'How it works' },
  { href: '#contact', label: 'Contact' }
]

const onScroll = () => { scrolled.value = window.scrollY > 8 }

onMounted(() => { onScroll(); window.addEventListener('scroll', onScroll, { passive: true }) })
onUnmounted(() => window.removeEventListener('scroll', onScroll))
</script>
